import ProjectsIndexTableRowRenderer from './ProjectsIndexTableRowRenderer';
import IconArrowDown from '../icons/IconArrowDown';

export default class GroupedProjectsTableRowRenderer extends ProjectsIndexTableRowRenderer {

    constructor(props, indexTableRow) {
        super(props, indexTableRow);
    }

    renderIndexTableRow() {
        const isGroupItem = this.props.row.childs.length === 0;
        const rowClassNames = [
            this.props.row.hidden ? 'project--hidden' : '',
            isGroupItem ? 'index-table-row-small-padding' : ''
        ];

        return (
            <React.Fragment>
                <tr key={this.props.row.id} className={rowClassNames.join(' ')}>
                    {isGroupItem ? (
                        <td></td>
                    ) : (
                        <td>
                            <div className={`projects-table-row-expander ${this.props.isGroupOpen ? 'open' : ''}`}
                                 onClick={() => this.props.onExpanderClick(this.props.row.id)}>
                                <IconArrowDown color="#ffffff"/>
                            </div>
                        </td>
                    )}
                    {this.indexTableRow.renderCheckbox()}
                    {this.indexTableRow.props.columns.map((column, idx) => (
                        <React.Fragment key={idx}>
                            {this.indexTableRow.renderDataCell(column, this.indexTableRow.findValueByColumnSlug(column.slug))}
                        </React.Fragment>
                    ))}
                    {this.indexTableRow.renderBaseActionButtons()}
                </tr>
                {this.renderConfigurations()}
            </React.Fragment>
        )
    }
}